import { render, staticRenderFns } from "./PopupManager.vue?vue&type=template&id=f8b63f5c&scoped=true&"
import script from "./PopupManager.vue?vue&type=script&lang=js&"
export * from "./PopupManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b63f5c",
  null
  
)

export default component.exports